// extracted by mini-css-extract-plugin
export default {"root":"SellerFollowButton-root"};